<template>
  <div class="csv-fields-defination">
    <b-container fluid class="headLine" id="common-mapping-head">
      <div cols="6" class="container-fluid">
        <h6 class="title d-flex">
          実績データ項目の選択
        </h6>
        <!-- Start header mapping RESULT CSV -->
        <span class="sub-title">
          バッチ画面の「実績DL」ボタンを押した時に出力されるCSVファイルの設定です。必要な項目だけ選んで、並べ替えてください。
        </span>
        <!-- End header mapping RESULT CSV -->
      </div>
      <div cols="6" class="container-right">
        <!-- Start button add mapping WMS -->
        <a class="add-single mr-0" @click="showCsvFields">
          <span class="material-icons"> add </span>
          追加
        </a>
        <div
          :class="[
            'mst-item-list',
            !selectedItems.length
              ? 'mst-item-list__no-data'
              : 'mst-item-list__has-data'
          ]"
          v-if="isShowCsvFields"
          v-click-outside="() => (isShowCsvFields = !isShowCsvFields)"
        >
          <span class="label">タスク明細テーブルから選択</span>
          <span class="label-no-data" v-if="!selectedItems.length"
            >全ての項目を選択中です。</span
          >
          <b-list-group>
            <b-list-group-item
              button
              v-for="(mstItem, index) in selectedItems"
              :key="`choose-mst-item_${index}`"
              @click="addCsvField(mstItem, index)"
            >
              <span class="number-mst-item">{{ index + 1 }}.</span>
              <span class="mst-item-name">{{ mstItem.isItemName }}</span>
            </b-list-group-item>
          </b-list-group>
        </div>
        <!-- End button add mapping WMS -->
      </div>
    </b-container>
    <div id="scrollspy-mapping">
      <div class="no-data" v-if="isEmptyData">
        <span>項目を追加してください。</span>
      </div>
      <b-container fluid class="pr-0">
        <draggable v-model="mstItemList">
          <!-- Start table mapping WMS -->
          <div
            v-for="(mstItem, index) in mstItemList"
            :key="`mst_${index}`"
            :id="`mst-item-mapping-${index}`"
          >
            <div class="item-mapping" :id="`${mappingNo}-${index}`">
              <span class="ordinalNumber">{{ index + 1 }}列</span>
              <b-list-group-item
                class="active-hover"
                @mousedown="handleShowIconDragById(index)"
                @mouseover="handleShowIconDragById(index)"
                @mouseleave="chooseIndex = null"
              >
                <b-container fluid class="item-column">
                  <div class="custom-draggable">
                    <div class="left-column">
                      <span
                        :class="['icon_drag drag_indicator material-icons material-icons-outlined',
                          chooseIndex === index ? 'd-flex' : 'd-none'
                        ]"
                      >
                        drag_indicator
                      </span>
                      <div class="hovering-bg-color">
                        <span class="label">
                          {{ mstItem.isItemName }}
                        </span>
                        <!-- Change icon -->
                        <template v-if="chooseIndex === index">
                          <b-dropdown
                            size="lg"
                            :ref="`dropdownCSV-${index}`"
                            offset="25"
                            dropup
                            variant="link"
                            toggle-class="text-decoration-none p-0"
                            no-caret
                            @show="() => (isShowCsvFields = false)"
                          >
                            <template #button-content>
                              <span class="material-icons edit_icon d-flex align-items-center">edit</span>
                            </template>
                            <div class="custom-form-dropdown">
                              <span class="label"
                                >タスク明細テーブルから選択</span
                              >
                              <span
                                class="label-no-data"
                                v-if="!selectedItems.length"
                                >全ての項目を選択中です。</span
                              >
                              <div class="custom-dropdown-list">
                                <b-dropdown-item
                                  v-for="(selected,
                                  indxSelected) in selectedItems"
                                  :key="`dropdown-mst-item_${indxSelected}`"
                                  @click="
                                    handleChangedItem(selected, index, mstItem)
                                  "
                                >
                                  <span class="number-mst-item"
                                    >{{ indxSelected + 1 }}.</span
                                  >
                                  <span class="mst-item-name">{{
                                    selected.isItemName
                                  }}</span>
                                </b-dropdown-item>
                              </div>
                            </div>
                          </b-dropdown>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="right-column">
                    <!-- Delete icon -->
                    <a
                      @click="onItemDelete(index)"
                      class="d-flex align-items-center text-decoration-none"
                    >
                      <span class="material-icons delete_icon"> close </span>
                    </a>
                  </div>
                </b-container>
              </b-list-group-item>
            </div>
          </div>
        </draggable>
        <!-- End table mapping WMS -->
      </b-container>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import FlashMessage from '../../common/flash-message.component'
import Vue from 'vue'

export default {
  props: {
    mappingNo: String
  },
  components: {
    draggable
  },
  data() {
    return {
      mstItemList: [],
      chooseIndex: null,
      isLoading: false,
      editLabelList: [],
      selectedItems: [],
      chosenItem: {},
      originalMstItemList: [],
      isShowCsvFields: false,
      mappingData: {},
      isEmptyData: false
    }
  },
  async created() {
    await this.fetchRequest()
    await this.generateFeatchDataMstItemMapping(this.mappingData)
  },
  watch: {
    isLoading() {
      this.$emit('isLoading', this.isLoading)
    },
    mstItemList(newValue) {
      this.isEmptyData = !newValue.length
    }
  },
  computed: {},
  methods: {
    /** データを取得する */
    async fetchRequest() {
      const res = await this.$axios.get(`/mapping/${this.mappingNo}`)
      this.mappingData = res.data
    },
    /**
     * 編集アイコンを表示
     * @param index リスト データのインデックス
     */
    handleShowIconDragById(index) {
      this.chooseIndex = index
    },
    /**
     * WMSアイテムの削除
     * @param index   リスト データのインデックス
     */
    onItemDelete(removeIndex) {
      const item = this.mstItemList[removeIndex]
      this.selectedItems.push(item)
      this.sortSelectItems()
      this.mstItemList.splice(removeIndex, 1)
    },
    /**
     *  変更が必要なリスト選択を表示し、選択項目を設定します
     * @param index   リスト データのインデックス
     * @param mstItem データ一覧の項目
     */
    handleOnChange(index, mstItem) {
      this.isShowCsvFields = !this.isShowCsvFields
      this.chosenItem = { mstItem, index }
    },
    /**
     * 削除されたアイテムでアイテムを変更する
     * @param selectedItem 変わるという選択
     * @param index 変更する要素の位置
     * @param mstItem 変更する項目
     */
    handleChangedItem(selectedItem, index, mstItem) {
      // Add item has changed in selectedItems
      this.selectedItems.push(mstItem)
      // Delete item has chosen in selectedItems
      this.selectedItems.map((selected, index) => {
        if (selected.isItemNo === selectedItem.isItemNo) {
          this.selectedItems.splice(index, 1)
        }
      })
      // Replace index wanna change by item has chosen on selectedItems for mstItemList
      this.mstItemList.splice(index, 1, selectedItem)
      this.sortSelectItems()
    },
    /** リスト選択を seqNo フィールドの昇順でソートします */
    sortSelectItems() {
      this.selectedItems.sort(
        (firstElement, secondElement) =>
          firstElement.seqNo - secondElement.seqNo
      )
    },
    /** mst アイテム リストを lineNum フィールドの昇順で並べ替えます */
    sortMstItemList() {
      this.mstItemList.sort(
        (firstElement, secondElement) =>
          firstElement.lineNum - secondElement.lineNum
      )
    },
    /** csv フィールド リストを表示 */
    showCsvFields() {
      this.isShowCsvFields = !this.isShowCsvFields
    },
    /** csv フィールドを追加 */
    addCsvField(item, removeIndex) {
      this.mstItemList.push(item)
      this.selectedItems.splice(removeIndex, 1)
      let index = this.mstItemList.length - 1
      Vue.nextTick(() => this.scrollToEnd(index))
    },
    /** 最後までスクロール */
    scrollToEnd(lastIndex) {
      let idItemMapping = 'mst-item-mapping'
      const lastElm = document.getElementById(`${idItemMapping}-` + lastIndex)
      const scrollspyElm = document.getElementById('scrollspy-mapping')
      const scrollspyHeight = scrollspyElm.offsetHeight
      if (lastElm.offsetTop > scrollspyHeight) {
        scrollspyElm.scrollTo({
          top: lastElm.offsetTop - scrollspyHeight + lastElm.offsetHeight,
          behavior: 'smooth'
        })
      }
    },
    /** マッピングデータ保存処理 */
    async saveCsvMapping() {
      this.isLoading = true
      try {
        let mstItemData = []
        this.originalMstItemList.map(originalItem => {
          let lineNum
          // If on UI has mst's isItemNo equal originalItem's isItemNo, will set originalItem's isItemEnabledFlag is 1
          const resultMstItem = this.mstItemList.some((mst, index) => {
            lineNum = ++index
            return originalItem.isItemNo === mst.isItemNo
          })
          originalItem.isItemEnabledFlag = resultMstItem ? 1 : 0
          mstItemData.push({
            isItemEnabledFlag: originalItem.isItemEnabledFlag,
            isItemName: originalItem.isItemName,
            isItemNo: originalItem.isItemNo,
            mappingNo: originalItem.mappingNo,
            lineNum: resultMstItem ? lineNum : 1,
            serialNo: 1
          })
        })
        await this.$axios.post(`/mapping/${this.mappingNo}`, {
          mstMappingIsItem: mstItemData
        })
        this.isLoading = false
        FlashMessage.getInstance().showSuccessMessage('保存完了。')
      } catch (err) {
        this.isLoading = false
        FlashMessage.getInstance().parseAndShowErrorMessage(err)
      }
    },
    /** データを取得する */
    generateFeatchDataMstItemMapping(mappingData) {
      this.mstItemList = []
      this.selectedItems = []
      this.originalMstItemList = []
      if (!mappingData) {
        return
      }
      mappingData.mstIsItem.forEach((item, index) => {
        const resultsManageData = mappingData.mstTableManagement.filter(
          mstManag => mstManag.isItemNo === item.isItemNo
        )
        // Add item name for label of item mapping column
        item['isItemName'] = resultsManageData.length
          ? resultsManageData[0].itemName
          : ''
        const resultsMstItem = mappingData.mstMappingIsItem.filter(
          mstItem => mstItem.isItemNo === item.isItemNo
        )
        if (resultsMstItem.length) {
          // Build data for mst item list if user has mapped or mst item list has system default value
          item['isItemEnabledFlag'] = resultsMstItem[0].isItemEnabledFlag
          item['userDefineValue'] = resultsMstItem[0].userDefineValue
          item['lineNum'] = resultsMstItem[0].lineNum
        } else {
          // Build data default for mst item list if user don't mapping
          item['isItemEnabledFlag'] = 0
          item['userDefineValue'] = null
          item['lineNum'] = null
        }
        item.isItemEnabledFlag
          ? this.mstItemList.push(item)
          : this.selectedItems.push(item)
        this.sortMstItemList()
        this.originalMstItemList.push(item)
      })
      if (this.mstItemList.length) {
        this.isEmptyData = false
      } else {
        this.isEmptyData = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.csv-fields-defination {
  // 70px (Area tab and action button mapping)
  height: calc(100% - 70px);
  .item-mapping {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100% !important;
    .active-hover {
      &:hover {
        cursor: pointer;
        background: $text_hover_bg_color;
      }
    }
    .ordinalNumber {
      white-space: nowrap;
      @include responsive-fs(16);
      min-width: 50px;
      width: 5%;
      max-width: 120px;
    }
    .list-group-item,
    .mst_item_list {
      background: #ffffff;
      border: 1px solid #d6d6d6;
      border-radius: 4px;
      padding: 2px 0px;
      margin: 2px 0 1px 0;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      width: 100%;
      height: 48px;
      &.hovering {
        background: $text_hover_bg_color;
      }
      .item-column {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .custom-draggable {
          display: flex;
          align-content: center;
          justify-items: center;
          width: 100%;
          .icon_drag {
            cursor: pointer;
            color: #afafae;
            margin-right: 7px;
            &:hover {
              background: $text_hover_bg_color;
            }
          }
          .left-column {
            display: flex;
            align-items: center;
            height: 26px;
            width: 100%;
            .label {
              @include textOverflowEllipsis(true);
              padding-right: 16px;
            }
            .hovering-bg-color {
              display: flex;
              padding: 8px;
              &:hover {
                background: $text_hover_bg_color;
              }
            }
          }
        }
      }
    }
    .mst_item_list {
      height: 65px;
      .item-column {
        width: 100%;
        height: 62px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .mst-left-column {
          display: flex;
          flex-direction: column;
          padding: 4px 8px;
          width: 100%;
          .label {
            display: -webkit-box;
            // max-width: 200px;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .edit-mapping-item {
            display: flex;
            align-items: center;
            .mappingItem-label {
              display: -webkit-box;
              // max-width: 200px;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }
        }
      }
    }
    .list-group {
      list-style-type: none;
      min-height: 46px;
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }
  .headLine {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0px 0px 10px 0px;
    padding-right: 0px !important;
    padding-left: 0px;
    max-height: 100px;
    .title {
      font-weight: 900;
    }
    .sub-title {
      font-weight: 400;
      @include responsive-fs(12);
      color: #666563;
      @include textOverflowEllipsis(true);
    }
    .container-right {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: nowrap;
      width: auto;
      .add-single,
      .add-all {
        display: flex;
        align-items: center;
        text-decoration: none;
        font-weight: 400;
        @include responsive-fs(18);
        line-height: 160%;
        user-select: none;
        &:hover {
          cursor: pointer;
        }
      }
      .add-single {
        margin-right: 24px;
        min-width: 60px;
        white-space: nowrap;
      }
      .add-all {
        min-width: 96px;
      }
      .input-group {
        text-indent: 0px !important;
        min-width: 226px;
        .custom_form {
          border-right: none;
          padding-right: 32px;
          border-right: none;
          position: relative;
        }
      }
      .mst-item-list {
        display: flex;
        flex-direction: column;
        padding: 0px;
        position: absolute;
        z-index: 1;
        width: max-content;
        min-width: 250px;
        top: 30px;
        background: #ffffff;
        box-shadow: 0px 4px 10px rgba(51, 51, 51, 0.12);
        border-radius: 0px 0px 8px 8px;
        &__no-data {
          height: fit-content;
          min-height: 115px;
        }
        &__has-data {
          max-height: 300px;
        }
        .label {
          @include responsive-fs(12);
          font-weight: 700;
          padding-top: 16px;
          padding-left: 16px;
        }
        .label-no-data {
          @include responsive-fs(16);
          margin: 20px 10px 10px 20px;
        }
        .list-group {
          width: 100%;
          overflow-y: auto;
          .list-group-item {
            border: none;
            margin: 0 16px;
            display: flex;
            align-items: center;
            padding: 4px 0px 4px 8px;
            width: auto;
            height: 32px;
            &:hover {
              border-radius: 8px;
              background: $text_hover_bg_color;
            }
            .number-mst-item {
              width: 40px;
              text-align: left;
            }
            .mst-item-name {
              // 40px is width of number mst item
              max-width: calc(100% - 40px);
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              text-align: left;
            }
            &:last-child {
              margin-bottom: 20px;
            }
          }
        }
      }
    }
  }

  // MATERIAL ICONS CUSTOM
  .material-icons {
    &.edit_icon {
      color: $sucess;
      cursor: pointer;
      @include responsive-fs(18);
    }
    &.delete_icon {
      color: #afafae;
      user-select: none;
      &:hover {
        cursor: pointer;
        background: $text_hover_bg_color;
      }
    }
  }
  // Dropdown menu
  /deep/ button[aria-haspopup='menu'].dropdown-toggle {
    padding: 0;
  }
  /deep/ ul[role='menu'].dropdown-menu.show {
    width: 250px;
    height: 250px;
    border-radius: 0px 0px 8px 8px;
    position: relative;
    @media only screen and (max-width: 1280px) {
      height: 200px;
    }
    .custom-form-dropdown {
      display: flex;
      flex-direction: column;
      .label {
        @include responsive-fs(12);
        font-weight: 700;
        padding-top: 16px;
        padding-left: 16px;
      }
      .label-no-data {
        @include responsive-fs(16);
        margin: 20px 10px 10px 20px;
      }
      .custom-dropdown-list {
        width: 245px;
        overflow-y: auto;
        height: 200px;
        @media only screen and (max-width: 1280px) {
          height: 160px;
        }
        a {
          margin: 0 16px;
          display: flex;
          align-items: center;
          padding: 4px 0px 4px 8px;
          width: auto;
          &:hover {
            border-radius: 8px;
            background: $text_hover_bg_color;
          }
          .number-mst-item {
            width: 40px;
            text-align: left;
          }
          .mst-item-name {
            // 40px is width of number mst item
            max-width: calc(100% - 40px);
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            text-align: left;
          }
        }
        &:last-child {
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/CommonCsvFieldDefinition.vue